import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '../ui/dialog';
import { Button } from '../ui/button';
import { Textarea } from '../ui/textarea';
import { PenLine, Send, Loader2 } from 'lucide-react';
import { useLanguage } from '../../context/AppContext';

const TextMealInputModal = ({
  open,
  onOpenChange,
  textMealForm,
  onFormChange,
  onSubmit,
  analyzing
}) => {
  const { language, t } = useLanguage();

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-card border-border max-w-lg">
        <DialogHeader>
          <DialogTitle className="font-heading text-2xl uppercase tracking-tight flex items-center gap-2">
            <PenLine className="w-6 h-6 text-primary" />
            {t('modals.text_meal_title')}
          </DialogTitle>
          <DialogDescription>
            {language === 'fr'
              ? 'YUMIX analysera ta description pour estimer les macros.'
              : 'YUMIX will analyze your description to estimate macros.'}
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-5 py-4">
          {/* Description */}
          <div className="space-y-2">
            <label className="text-sm font-medium text-foreground">
              {language === 'fr' ? 'Description du repas' : 'Meal description'}
            </label>
            <Textarea
              value={textMealForm.description}
              onChange={(e) => onFormChange({ ...textMealForm, description: e.target.value })}
              placeholder={t('modals.text_meal_placeholder')}
              className="bg-secondary border-border min-h-[120px] resize-none"
              data-testid="meal-description-input"
            />
            <p className="text-xs text-muted-foreground">
              {language === 'fr'
                ? 'Sois précis sur les aliments et les quantités pour une meilleure estimation.'
                : 'Be specific about foods and quantities for better estimation.'}
            </p>
          </div>
          {/* YUMIX tip */}
          <div className="flex items-start gap-3 p-3 bg-primary/10 border border-primary/30 rounded-lg">
            <img
              src="/mascot-yuri.png"
              alt="Coach Yuri"
              className="w-10 h-10 object-contain flex-shrink-0"
            />
            <p className="text-sm text-foreground">
              {language === 'fr'
                ? "Astuce: Mentionne les légumes et super-aliments pour gagner plus de points!"
                : "Tip: Mention vegetables and superfoods to earn more points!"}
            </p>
          </div>
          {/* Submit Button */}
          <Button
            onClick={onSubmit}
            disabled={analyzing || textMealForm.description.trim().length < 5}
            className="w-full bg-primary hover:bg-primary/90 text-primary-foreground"
            data-testid="submit-text-meal-btn"
          >
            {analyzing ? (
              <Loader2 className="w-4 h-4 mr-2 animate-spin" />
            ) : (
              <Send className="w-4 h-4 mr-2" />
            )}
            {t('modals.text_meal_analyze')}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default TextMealInputModal;
